module.exports = __webpack_public_path__ + "img/30.7d653f5b.png";